import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../Modal/Store';
import GroupParticipantsStore from './GroupParticipantsStore/Store';
import GroupView from './GroupView';
import Skeleton from '../Participants/Skeleton';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
  modalStore: ModalStore;
}

const GroupState: React.FC<Props> = ({ groupParticipantsStore, modalStore }) => {
  switch (groupParticipantsStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'loading-more':
      return <Skeleton filterCount={3} tableColCount={7} checkBoxRequirement="not-required" />;
    case 'ready':
    case 'updating-query':
    case 'updating-search-parameters':
    case 'sorting':
      return (
        <GroupView
          groupParticipantsStore={groupParticipantsStore}
          modalStore={modalStore}
          groupParticipantsState={groupParticipantsStore.state}
        />
      );
    case 'error':
      return <></>;
  }
};

export default observer(GroupState);
